<template>
  <select
    class="secondary_title all-option-select"
    v-model="addproduct[index].variant_id"
    @change="selectvariants({}, index)"
  >
    <option v-for="subitem in options" :key="subitem.ID" :value="subitem.ID">
      <span
        v-for="(option, optionindex) in subitem.attrs"
        :key="subitem.ID + optionindex + option.value"
      >
        {{
          optionindex == subitem.attrs.length - 1
            ? option.value
            : option.value + " / "
        }}
      </span>
    </option>
  </select>
</template>
<script>
export default {
  props: {
    options: {},
    addproduct: {},
    index: {},
    selectvariants: {},
  },
  data() {
    return {};
  },
};
</script>
<style scoped lang='scss'>
.all-option-select {
  width: 100%;
  border: 1px solid #dfdfdf;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 2px 10px;
  box-sizing: border-box;
  z-index: 1;
  position: relative;
  color: #737373;
  border-radius: 4px;
  outline: 0;
  line-height: 1;
  background-color: transparent;
  cursor: pointer;
  font-size: 12px;
  option {
    max-width: 100%;
  }
}
@media screen and(max-width:768px) {
  .all-option-select {
    padding: 5px 10px;
  }
}
</style>